<template>
  <div id="share_card_outer">
    <div>
      <div id="share_qr" ref="shareCodeDiv"></div>
      <div style="text-align: center;margin-top: 10px;">扫码二维码分享到微信</div>

      <a class="iconfont close-button" href="javascript:void(null);" @click="closeButtonClicked">&#xe639;</a>

    </div>
  </div>
</template>

<script>
  import QRCode from 'qrcodejs2';
export default {
  name: "ShareCard",
  props: [
    'url'
  ],
  mounted() {
    if (this.url != undefined && this.url != null && this.url != '') {
      this.bindQRCode();
    }
  },
  methods: {
    bindQRCode() {

      new QRCode(this.$refs.shareCodeDiv, {
        text: this.url,
        width: 200,
        height: 200,
        colorDark: '#333333',
        colorLight: '#ffffff',
        correctLevel: QRCode.CorrectLevel.L
      });
    },
    closeButtonClicked() {
      this.$emit('close');
    }
  }
}
</script>

<style scoped>

  #share_card_outer {
    background-color: rgba(0,0,0,0.2);
    position: fixed;
    width: 100vw;
    height: 100vh;
    left: 0;
    top: 0;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }

  #share_card_outer > div {
    background-color: white;
    padding-left: 30px;
    padding-right: 30px;
    padding-bottom: 15px;
    position: relative;
  }

  #share_qr {
    width: 200px;
    height: 200px;
    margin-top: 40px;
  }
  #share_card_outer .close-button {
    position: absolute;
    top: 0;
    right: 3px;
    color: black;
    font-size: 3rem;
    text-decoration: none;
  }

</style>



// WEBPACK FOOTER //
// src/components/share/ShareCard.vue